<div class="renew-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon class="header-icon">autorenew</mat-icon>
      Renew subscription
    </h2>
    <button mat-icon-button (click)="close()" class="close-button" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="hint">
      Subscription #{{ data.subscription?.id }} will keep the current domains and seats.
      The new term starts when the current one ends (or today if it has already expired).
    </p>

    <label class="field-label">Duration (months)</label>
    <select class="form-input" [(ngModel)]="duration" (ngModelChange)="recalculate()">
      <option *ngFor="let month of monthOptions" [ngValue]="month">
        {{ month }} month{{ month > 1 ? 's' : '' }}
      </option>
    </select>

    <div class="summary-card">
      <div class="summary-row">
        <span>Subtotal</span>
        <span>{{ formatCurrency(subtotal) }}</span>
      </div>
      <div class="summary-row">
        <span>GST (18%)</span>
        <span>{{ formatCurrency(gstAmount) }}</span>
      </div>
      <div class="summary-row total-row">
        <span><strong>Amount due</strong></span>
        <span><strong>{{ formatCurrency(orderTotal) }}</strong></span>
      </div>
      <p class="hint" *ngIf="calculating">Calculating…</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()" [disabled]="loading">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="proceedToPayment()"
      [disabled]="loading || calculating || orderTotal <= 0"
    >
      {{ loading ? 'Processing…' : 'Pay with Razorpay' }}
    </button>
  </mat-dialog-actions>
</div>
